<template>
  <div class="save-modal-wrapper-table" @click="closeModal">
    <div class="save-modal">
      <h5>Save your search parameters</h5>
      <input type="text" placeholder="Search"/>
      <div class="user-actions">
        <button class="orange-btn cancel" @click="closeModal">Cancel</button>
        <button class="orange-btn" @click.prevent='saveModal'>Save</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['searchRowItemData'],

  methods: {
    closeModal(e) {
      let target = e.target.className;
      
      if(target.includes('save-modal-wrapper-table') || target.includes('orange-btn')) {
        document.querySelector('.save-modal-wrapper-table').style.opacity = '0';
        document.querySelector('.save-modal-wrapper-table').style.zIndex = '-999';
        document.querySelector('body').style.overflow = 'auto';
      } else if(target.includes('cancel')) {
        document.querySelector('.save-modal-wrapper-table').style.opacity = '0';
        document.querySelector('.save-modal-wrapper-table').style.zIndex = '-999';
        document.querySelector('body').style.overflow = 'auto';
      }
    },

    saveModal() {
      let value = document.querySelector('.save-modal-wrapper-table .save-modal input').value;
      this.$emit('save', value, this.searchRowItemData);
    }
  }
}
</script>

<style lang="scss">
  .save-modal-wrapper-table {
    width: 100%;
    height: calc(100% + 91px);
    position: fixed;
    top: 0;
    left: 0;
    opacity: 0;
    z-index: -999;
    display: flex;
    justify-content: center;
    align-items: flex-start;

    .save-modal {
      background: #fff;
      padding: 40px 50px;
      margin-top: 200px;
      box-shadow: 0px 4px 15px rgba(51, 51, 51, 0.03);
      border-radius: 15px;
      width: 490px;
      text-align: center;

      h5 {
        margin-bottom: 40px;
        font-size: 26px;
        line-height: 25px;
      }

      input {
        width: 100%;
        margin-bottom: 35px;
        border: 1px solid #CDCDCD;
        border-radius: 5px;
        padding: 16px 20px;

        &:focus {
          outline: none;
        }
      }

      .user-actions {
        display: flex;
        justify-content: space-between;

        .orange-btn {
          width: 170px;
          border: none;
          font-family: "Gotham-Book";

          &.cancel {
            background: #ebebeb;
            color: #333;
          }

          &:focus {
            outline: none;
          }
        }
      }
    }
  }
</style>